export default "__VITE_ASSET__a67aac67__"